import CustomTable from "components/table";
import Config from "config";
import dayjs from "dayjs";
import { Chain, CustomerInterface, CustomerTransactionStatus, Token, TransactionInterface } from "interfaces";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "reducer/store";
import { Button, Card, Pagination } from "semantic-ui-react";
import { api, utils } from "services";
import { ActionComponent } from "./action";
import keplrService from "services/keplr";


export const TransactionTable = ({ trigger, setTrigger, recentTransaction }: any) => {
    const displayTransactionStatus = (
        transactionStatus: any,
        lockTime: any,
        claim_at: any
    ) => {
        switch (transactionStatus) {
            case CustomerTransactionStatus.Canceled:
                return <div className="text-red">CANCELED</div>;
            case CustomerTransactionStatus.Claimed:
                return <div className="text-green">SUCCESS</div>;
            case CustomerTransactionStatus.Pending:
            default:
                if (
                    dayjs().isAfter(dayjs(claim_at)) &&
                    !(lockTime && dayjs(lockTime).isAfter(dayjs()))
                ) {
                    return <div className="text-green">CLAIMABLE</div>;
                }
                if (lockTime && dayjs(lockTime).isAfter(dayjs())) {
                    return <div className="text-orange">PROCESSING</div>;
                }
                return <div className="text-orange">PENDING</div>;
        }
    };

    const tableHeader = [
        {
            fieldName: "ID",
            className: "",
            fieldKey: TransactionInterface.id,
        },
        {
            fieldName: "Amount",
            className: "",
            fieldKey: TransactionInterface.value,
            render: (children: any) => {
                return <div className="min-w-[80px]">{utils.toFixed(children ?? 0)}</div>;
            },
        },
        {
            fieldName: "Token",
            className: "",
            fieldKey: TransactionInterface.token_type,
            render: (children: any) => {
                return (
                    <div className="text-uppercase min-w-[80px]">
                        <img
                            className="h-6 w-6 mb-1 mx-1 inline-block"
                            src={`/assets/images/items/${!children ? "mag" : Token[children].toLocaleLowerCase()
                                }-icon.webp`}
                            alt="token"
                        />
                        {!children ? "mag" : Token[children].toLocaleLowerCase()}
                    </div>
                );
            },
        },
        {
            fieldName: "Request at",
            className: "",
            fieldKey: TransactionInterface.created_at,
            render: (children: any) => {
                return (
                    <div className="min-w-[120px]">
                        {children &&
                            new Date(children.toString()).toLocaleTimeString(
                                "en-us",
                                Config.FormattedTime as any
                            )}
                    </div>
                );
            },
        },
        {
            fieldName: "Return at",
            className: "",
            fieldKey: TransactionInterface.claim_at,
            render: (children: any) => {
                return (
                    <div className="min-w-[120px]">
                        {children &&
                            new Date(children.toString()).toLocaleTimeString(
                                "en-us",
                                Config.FormattedTime as any
                            )}
                    </div>
                );
            },
        },
        {
            fieldName: "Wallet address",
            className: "",
            fieldKey: TransactionInterface.wallet_address,
            render: (children: any) => {
                return <div>{utils.displayWalletAddress(children)}</div>;
            },
        },
        {
            fieldName: "Chain",
            className: "",
            fieldKey: TransactionInterface.chain,
            render: (children: any) => {
                return <div>{Chain[children ?? Chain.BSC]}</div>;
            },
        },
        {
            fieldName: "Status",
            className: "",
            fieldKey: "All",
            render: (children: any) => {
                let status = children[TransactionInterface.status];
                let lockTime = children[TransactionInterface.lock_processing];
                let claim_at = children[TransactionInterface.claim_at];
                return displayTransactionStatus(status, lockTime, claim_at);
            },
        },
        {
            fieldName: "Action",
            className: "text-center",
            fieldKey: "All",
            render: (children: any) => (
                <ActionComponent
                    data={children}
                    trigger={trigger}
                    setTrigger={setTrigger}
                />
            ),
        },
    ];

    const [transactions, setTransactions] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(1);
    const user = useSelector((state: RootState) => state.user);

    useEffect(() => {
        if (!sessionStorage.getItem("token") || !user?.[CustomerInterface.id]) {
            setTransactions([]);
            setTotal(0);
            return;
        }
        api
            .getTransactions({
                offset: limit * (page - 1),
                limit: limit,
            })
            .then((data) => {
                setTransactions(data.transactionInfos);
                setTotal(data.total);
            })
            .catch((err) => {
                console.log({ err });
            });
    }, [trigger, user?.[CustomerInterface.id], page, limit]);

    return (
        <div className="mt-10 w-full relative">
            <Card
                fluid
                style={{ background: "transparent", boxShadow: "none" }}
                description={
                    <div className="flex flex-col gap-4 relative">
                        <div className="float-left font-bold text-white text-lg md:text-2xl">
                            My transactions
                        </div>
                        <div className="mt-3 mb-10 bg-black-secondary text-white-light rounded-lg pb-10 w-full relative">
                            <CustomTable
                                className="min-h-[400px] overflow-y-scroll"
                                tableHeader={tableHeader}
                                tableData={transactions}
                                highlight={[recentTransaction]}
                                overrideHeader=""
                                highlightField={TransactionInterface.id}
                            />
                            {total / limit > 1 && (
                                <Pagination
                                    defaultActivePage={page}
                                    totalPages={Math.ceil(total / limit)}
                                    onPageChange={(event: any, pageInfo) => {
                                        setPage(Number(pageInfo.activePage));
                                    }}
                                    firstItem={null}
                                    lastItem={null}
                                    className="bg-black-secondary"
                                    style={{ float: "right" }}
                                />
                            )}
                        </div>
                    </div>
                }
            />
        </div>
    )
}